export const toCurrency = (value) => {
  return parseFloat(value).toLocaleString('es-CL')
}
export const toRaw = (value) => {
  const unformattedValue = value.replace(/[.,]/g, '')
  return parseInt(unformattedValue)
}
